module.exports = __webpack_public_path__ + "static/media/pariscope.898f8ae5.png";